import BackIcon from 'assets/images/header/white-back.svg'
import { useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className=" bg-green-1 w-full px-2 py-3 flex justify-between sticky top-0 z-10 shadow-[0px 2px 4px 0px #0000001A] items-center">
            <img
                src={BackIcon}
                alt="back"
                onClick={() => navigate(-1)}
                className=" cursor-pointer"
            />
            <p className=" text-white font-black text-right">{title}</p>
            <p className=" text-green-1">1111212</p>
        </div>
    )
}
